<script setup lang="ts">
import { computed, ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import NavBar from './components/NavBar.vue';

const route = useRoute();
const router = useRouter();
const sidebarVisible = ref(true);
const sidebarVisibleMobile = ref(false);
const isMobile = ref(false);
const isAppReady = ref(false);

const showNavbar = computed(() => {
  return route.name !== 'login' && route.name !== 'register' && route.name !== 'unauthorized' && route.name !== 'sharedLink'
})

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
  if (isMobile.value) {
    sidebarVisible.value = false;
  }
}

onMounted(() => {
  // Esperar a que Vue termine de evaluar la ruta actual
  router.isReady().then(() => {
    isAppReady.value = true;
  });

  checkMobile();
  window.addEventListener('resize', checkMobile);
})

const toggleSidebar = () => {
  sidebarVisible.value = !sidebarVisible.value;
}

const toggleSidebarMobile = () => {
  sidebarVisibleMobile.value = !sidebarVisibleMobile.value;
}

// Cerrar el sidebar móvil cuando cambia la ruta
watch(() => route.path, () => {
  sidebarVisibleMobile.value = false;
})
</script>

<template >
  <div class="layout-wrapper" :class="{ 'layout-with-sidebar': showNavbar }" v-if="isAppReady">
    <div v-if="showNavbar " class="mobile-navbar">
      <div class="mobile-navbar-content">
        <Image src="/logo.png" alt="logo" height="40" style="cursor: pointer" @click="router.push('/')" />
        <Button icon="pi pi-bars" text rounded @click="toggleSidebarMobile" />
      </div>
    </div>
    <NavBar v-if="showNavbar" :visible="sidebarVisible" :visible-mobile="sidebarVisibleMobile"
      @toggle="toggleSidebar" />
    <div v-if="showNavbar && sidebarVisibleMobile" class="sidebar-overlay" @click="toggleSidebarMobile"></div>
    <div class="layout-main"
      :class="{ 'layout-main-expanded': !sidebarVisible, 'layout-main-hidenavbar': !showNavbar }">
      <RouterView :key="route.path" />
    </div>
  </div>
</template>

<style>
.layout-wrapper {
  min-height: 100vh;
  display: flex;
  width: 100%;
  overflow-x: hidden;
}

.layout-with-sidebar {
  transition: padding-left 0.3s;
}

.layout-with-sidebar-collapsed {
  padding-left: 4rem;
}

.layout-main {
  flex: 1;
  min-height: 100vh;
  margin-left: 280px;
  transition: all 0.3s;
  width: calc(100% - 280px);
}

.layout-main-expanded {
  margin-left: 4rem;
  width: calc(100% - 4rem);
}

.layout-main-hidenavbar {
  margin-left: 0;
  width: 100%;
}

.mobile-navbar {
  width: 100%;
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 4rem;
  background-color: var(--surface-card);
  border-bottom: 1px solid var(--surface-border);
  z-index: 1000;
}

.mobile-navbar-content {
  height: 100%;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 998;
}

@media screen and (max-width: 768px) {
  .layout-with-sidebar {
    padding-left: 0;
  }

  .layout-with-sidebar-collapsed {
    padding-left: 0;
  }

  .layout-main {
    margin-left: 0;
    width: 100%;
  }

  /* Solo aplicar margin-top cuando el navbar esté visible */
  .layout-with-sidebar .layout-main:not(.layout-main-hidenavbar) {
    margin-top: 4rem;
  }

  .layout-main-expanded {
    margin-left: 0;
    width: 100%;
  }

  .mobile-navbar {
    display: block;
  }

  .sidebar-overlay {
    display: block;
  }
}
</style>
